import { Routes } from '@angular/router';

export const edgeDevicesRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/edge-devices-list/edge-devices-list.component').then(
        (m) => m.EdgeDevicesListComponent
      ),
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./components/edge-device-detail/edge-device-detail.component').then(
        (m) => m.EdgeDeviceDetailComponent
      ),
    data: { breadcrumb: 'Device' },
  },
];
